// extracted by mini-css-extract-plugin
export default {"wrapper":"VerifyAddress_style_wrapper__38TIJ","heading":"VerifyAddress_style_heading__gRLOa","rotate":"VerifyAddress_style_rotate__d7hxC"};